export const KG = 1;
export const KZ = 4;
export const UZ = 15;

const _resourceNames = {
    [KG]: 'OPX',
    2: 'RUR',
    3: 'TJS',
    [KZ]: 'KZT',
    5: 'USD',
    6: 'EUR',
    7: 'GBP',
    8: 'KSH',
    9: 'PEN',
    10: 'VRT',
    [UZ]: 'UZS',
    101: 'WMZ',
    102: 'WMR',
    103: 'WME',
    104: 'WMU',
    201: 'YAD',
};
Object.defineProperty(_resourceNames, 'getCurrencyTag', {
    value: function (id = 5){
        switch (id) {
            case 1:
                return 'KGS'
            default:
                return this[id];
        }
    },
    enumerable: false,
    configurable: false,
    writable: false,
})
export const resourceNames = _resourceNames


// WEBPACK FOOTER //
// ./js/constants/accountResourceNames.js